<template>
    <view class="p30">
        <view class="title p30 bg-white f30 lh200 radius8">
			  <view>{{ detail.content }}</view>
			  <view v-for="(item, index) in img_list" :key="index">
			     <image :src="item.file_path" mode="aspectFit"></image>
			  </view>

        </view>
    
        </view>
    </view>
</template>

<script>
	import utils from '@/common/utils.js';
    export default {
        data() {
            return {
                detail: '',
				img_list:[]
            }
        },
		onLoad(e) {
			/*id*/
			this.upload_id = e.upload_id;
		},
        mounted(){
            uni.showLoading({
                title: '加载中'
            });
            this.getData();
        },
        methods: {
            getData(){
                let self = this;
				let upload_id = self.upload_id;
                self._get('plus.ticket.index/detail', {upload_id: upload_id}, function (res)
                {
					self.detail= res.data.detail;
					self.img_list= res.data.detail.image;
                    uni.hideLoading();
                });
            }
        }
    }
</script>

<style>

</style>
